import React, { useState } from 'react';
import Modal from '../../../../Components/Modal/Modal';
import { Size } from '../../../../Enums/Size.enum';
import { useTreatmentContext } from '../../../../Services/TreatmentContext';
import HealthPlanMonitoringTesting from '../HealthPlanMonitoringTesting/HealthPlanMonitoringTesting';
import HealthPlanMonitoring from './HealthPlanMonitoring';
import SecretButton from '../../../Base/Components/SecretButton/SecretButton';

interface HealthPlanMonitoringModalProps {
	opened: boolean;
	onClose: any;
}

const HealthPlanMonitoringModal: React.FC<HealthPlanMonitoringModalProps> = ({
	opened,
	onClose,
}) => {
	const { isCase } = useTreatmentContext();
	const [secretCounter, setSecretCounter] = useState(0);
	const [isTesting, setIsTesting] = useState(false);

	const handleSecretClick = () => {
		if (secretCounter > 9) {
			setIsTesting(true);
		}
		setSecretCounter(prev => prev + 1);
	};

	return (
		<Modal opened={opened} onClose={onClose} wrapChat={isCase} size={Size.LG}>
			<Modal.Header title={'component.healthPlan.item.monitoring'} />
			<Modal.Content contentScroll={true}>
				<div style={{ position: 'relative' }}>
					{isTesting ? (
						<HealthPlanMonitoringTesting onSuccess={onClose} />
					) : (
						<HealthPlanMonitoring onSuccess={onClose} />
					)}
					<SecretButton onClick={handleSecretClick} />
				</div>
			</Modal.Content>
		</Modal>
	);
};

export default HealthPlanMonitoringModal;
